/**
 * Fuente del total a pagar (ver `createPreInitiateTotalSource`).
 */
import { PaymentError } from '../domain/errors';
import type { PaymentMiddlewareClient } from './paymentMiddlewareClient';

export interface CheckoutTotalSource {
  getTotal(): Promise<number>;
}

export const createStaticCheckoutTotalSource = (total: number): CheckoutTotalSource => ({
  getTotal: async () => total,
});

const isValidTotal = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0;

/**
 * Total del pedido al bootstrap del iframe.
 *
 * Debe venir en `payment-init` como `totalAmount` (total del subcart en checkout web / app).
 * El backend rechaza `pre-initiate` con `instruments: []` (`instruments must not be empty`).
 * Las cuotas y el total neto por tarjeta se obtienen después con `pre-initiate` cuando hay cargos.
 */
export const createPreInitiateTotalSource = (
  _client: Pick<PaymentMiddlewareClient, 'preInitiate'>,
  appTotal?: number,
): CheckoutTotalSource => ({
  getTotal: async () => {
    if (isValidTotal(appTotal)) {
      return appTotal;
    }
    throw new PaymentError('Checkout total is not available (missing totalAmount from host)');
  },
});
